import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class ModuleSelectorAPI extends ComponentAPI {
    /**
     * Gets the module selector type.
     */
    getModuleType() {
        return this.state.moduleType;
    }
    /**
     * Sets the module selector type.
     *
     * @param moduleType - The module selector type.
     */
    setModuleType(moduleType) {
        this.setState({ moduleType });
    }
    /**
     * Returns if the modules icons will be shown in spatial desktop.
     */
    isShowIconsOnSpatialDesktop() {
        return this.state.showIconsOnSpatialDesktop;
    }
    /**
     * Sets if the modules icons will be shown in spatial desktop.
     *
     * @param showIconsOnSpatialDesktop - If the modules icons will be shown in spatial desktop.
     */
    setShowIconsOnSpatialDesktop(showIconsOnSpatialDesktop) {
        this.setState({ showIconsOnSpatialDesktop });
    }
    /**
     * Gets the module selector title.
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets the module selector title.
     *
     * @param title - The module selector title.
     */
    setTitle(title) {
        this.setState({ title });
    }
}
export { ModuleSelectorAPI, };
//# sourceMappingURL=module-selector-api.js.map